import { Link, useLocation } from "react-router-dom";
import Logo from "@/components/Logo";

const HIDE_ON = ["/watch", "/login", "/register", "/forgot-password", "/reset-password"];

export default function Footer() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname.startsWith(p))) return null;

  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/5 px-4 sm:px-12 py-10 mt-8">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        <div className="max-w-xs">
          <Logo size="md" />
          <p className="text-white/40 text-sm mt-3">Premium Burmese movies &amp; TV — rent or buy, anytime, on any device.</p>
          <p className="text-white/40 text-sm mt-2">Mandalay+ is run by Mandalay Media.</p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-white/60">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <Link to="/browse" className="hover:text-white transition-colors">Browse</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/distributors" data-testid="footer-distributors" className="hover:text-white transition-colors">Become a Distributor</Link>
          <Link to="/contact" data-testid="footer-contact" className="hover:text-white transition-colors">Contact / Advertise</Link>
        </nav>
      </div>
      <p className="text-white/30 text-xs mt-6">
        © {new Date().getFullYear()} Mandalay+ · A Mandalay Media company · www.mandalayplus.com · For partnerships & advertising: admin@mandalaymedia.com
      </p>
    </footer>
  );
}
